import { GameParams } from "supercell-frontend-base/src/validation/game-params";
import { z } from "zod";

export const ClashOfClansGameParams = GameParams.and(
    z.object({
        th: z.number().optional(), // Town hall level
        th2: z.number().optional(), // Builder's hut level
    }),
);

export type ClashOfClansGameParams = z.infer<typeof ClashOfClansGameParams>;
